var S = function (t) {
  return t.mmss = "mmss", t.hhmmss = "hhmmss", t;
}(S || {});

var u = function u(t) {
  var m = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "mmss";
  if (!t) return m === "hhmmss" ? "00:00:00" : "00:00";
  var s = Math.abs(Math.round(t)),
      r = Math.floor(s / 3600),
      h = Math.floor((s - r * 3600) / 60),
      c = s - r * 3600 - h * 60,
      a = String(r).padStart(2, "0"),
      n = String(h).padStart(2, "0"),
      o = String(c).padStart(2, "0");
  return m === "hhmmss" ? "".concat(a, ":").concat(n, ":").concat(o) : r ? "".concat(a, ":").concat(n, ":").concat(o) : "".concat(n, ":").concat(o);
};

export { S as DurationFormat, u as formatDuration };